export const MAX_PRIORITY_INGREDIENTS = 5;

export const FOCUS_AREA_PRIORITY_INGREDIENTS = {
  36: [39, 12, 28, 19, 21, 22], // Energy
  37: [24, 33, 34], // Focus & Memory
  38: [39, 12, 1, 28], // Sport Performance
  39: [39, 12, 1, 28], // Mood
  40: [39, 12, 1, 24], // Sleep
  41: [39, 12, 1, 19, 21, 22], // Stress
  42: [8, 35, 39, 12, 31], // Digestion
  43: [18, 27, 28, 31, 35], // Immune System
  44: [18, 27, 31], // Skin
  45: [25, 31], // Hair
  46: [39, 12, 25, 31], // Nails
  47: [6], // Heart
  48: [36, 18, 27, 29, 31], // Eyes
  49: [14, 8, 39, 12, 28], // Muscle Pain
  50: [14, 4, 39, 12, 28, 30], // Bones and Joints
  307: [39, 12, 24, 1, 8, 26], // Perimenopause / Menopause Symptoms
};

export const VITAMIN_B12_INGREDIENT_IDS = [34, 20];

const getRankedAnswerCodes = (priorityFocus) => {
  if (!Array.isArray(priorityFocus) || priorityFocus.length === 0) return [];

  return priorityFocus
    .filter((item) => item && typeof item === 'object' && item.answerCode !== undefined && item.answerCode !== null)
    .slice()
    .sort((a, b) => Number(a.rank || 0) - Number(b.rank || 0))
    .map((item) => Number(item.answerCode));
};

const buildPriorityIngredientIds = (priorityFocus) => {
  const orderedIds = [];
  const seen = new Set();

  getRankedAnswerCodes(priorityFocus).forEach((answerCode) => {
    const focusIngredientIds = FOCUS_AREA_PRIORITY_INGREDIENTS[answerCode] || [];
    focusIngredientIds.forEach((ingredientId) => {
      if (seen.has(ingredientId)) return;

      seen.add(ingredientId);
      orderedIds.push(ingredientId);
    });
  });

  return orderedIds;
};

const getIngredientId = (ingredient) => Number(ingredient?.ingredient_id);

export const orderIngredientsByFocusPriority = (ingredients, priorityFocus, { isVegan = false } = {}) => {
  if (!Array.isArray(ingredients) || ingredients.length === 0) return [];

  const presentIngredientIds = new Set(
    ingredients
      .map(getIngredientId)
      .filter((ingredientId) => Number.isFinite(ingredientId)),
  );
  const priorityIds = buildPriorityIngredientIds(priorityFocus)
    .filter((ingredientId) => presentIngredientIds.has(ingredientId))
    .slice(0, MAX_PRIORITY_INGREDIENTS);

  if (isVegan && !priorityIds.some((id) => VITAMIN_B12_INGREDIENT_IDS.includes(id))) {
    const b12IngredientId = VITAMIN_B12_INGREDIENT_IDS.find((id) =>
      presentIngredientIds.has(id),
    );

    if (b12IngredientId !== undefined) {
      if (priorityIds.length < MAX_PRIORITY_INGREDIENTS) {
        priorityIds.push(b12IngredientId);
      } else {
        priorityIds[MAX_PRIORITY_INGREDIENTS - 1] = b12IngredientId;
      }
    }
  }

  if (!priorityIds.length) return ingredients;

  const usedIndexes = new Set();
  const prioritizedIngredients = priorityIds
    .map((ingredientId) => {
      const matchedIndex = ingredients.findIndex(
        (item, index) => !usedIndexes.has(index) && getIngredientId(item) === ingredientId,
      );

      if (matchedIndex < 0) return null;
      usedIndexes.add(matchedIndex);
      return ingredients[matchedIndex];
    })
    .filter(Boolean);

  return [
    ...prioritizedIngredients,
    ...ingredients.filter((_, index) => !usedIndexes.has(index)),
  ];
};
